import { Component } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { Modal } from '../modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../services/contact.service';
import { config } from '../../../environments/specific/config';
import { BaseConfig } from 'src/environments/base-config.interface';
import { LoaderUtils } from 'src/app/utils/loader.utils';
import { ToastUtils } from 'src/app/utils/toast.utils';
import { environment } from 'src/environments/environment';
import { PickedFile } from '@capawesome/capacitor-file-picker';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss'],
})
export class ContactModalComponent extends Modal {
  private static readonly MAX_ATTACHMENTS = 5;

  contactForm: FormGroup = new FormGroup({
    subject: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
  });
  config: BaseConfig = config;
  allowAttachments =
    environment.config?.interface?.contactAllowAttachments === true;
  files: PickedFile[] = [];

  constructor(
    modalCtrl: ModalController,
    private contactService: ContactService
  ) {
    super(modalCtrl);
  }

  async contactMutuelle() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    await LoaderUtils.createAndPresent();
    const payload = {
      ...this.contactForm.value,
      ...(this.files.length > 0 && {
        files: this.files.map((file) => ({
          name: file.name,
          data: file.data,
        })),
      }),
    };
    this.contactService
      .contactMutuelle(payload)
      .then(() => {
        LoaderUtils.dismiss();
        this.close();
        ToastUtils.success('Votre message a bien été envoyé à la mutuelle');
      })
      .catch(() => {
        LoaderUtils.dismiss();
        ToastUtils.error(
          "Une erreur est survenue lors de l'envoi de votre message"
        );
      });
  }

  removeFile(file: PickedFile) {
    this.files.splice(this.files.indexOf(file), 1);
  }

  addFile($event: PickedFile[]) {
    for (const file of $event) {
      if (this.files.length >= ContactModalComponent.MAX_ATTACHMENTS) {
        break;
      }
      this.files.push(file);
    }
  }
}
